import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import { fetchCapOnLoanSuccess, setLoadingState } from '../actions';
import CapOnLoanAPI from '../api/CapOnLoanAPI';
import { FETCH_CAP_ON_LOAN } from '../constants/actionTypes';
import {
  accessTokenSelector,
  periodSelector,
  applicationIdSelector,
  otherFundsSelector,
  selectedCourseSelector,
  periodsSelector,
  futurePeriodsSelector,
  courseValidationSelector,
} from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* capOnLoanWatcher() {
  yield takeLatest(FETCH_CAP_ON_LOAN, capOnLoanWorker);
}

function* capOnLoanWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);

    const periods = yield select(periodsSelector);
    const period = yield select(periodSelector);
    const course = yield select(selectedCourseSelector);
    const futurePeriods = yield select(futurePeriodsSelector);
    const validatedCourse = yield select(courseValidationSelector);
    const { periodGuid } = period;
    const { value: courseGuid } = course;
    const numberOfPeriods = periods[courseGuid].length;

    const applicationId = yield select(applicationIdSelector);
    const productType = 'in_school';
    const otherFunds = yield select(otherFundsSelector);
    yield put(setLoadingState(true));
    const otherFundsParams = yield call(CapOnLoanAPI.paramsFrom, otherFunds);

    let payload;

    if (validatedCourse !== false) {
      payload = yield call(CapOnLoanAPI.maximumLoanAmountFor, periodGuid, accessToken, {
        applicationId,
        productType,
        ...otherFundsParams,
      });
    } else {
      payload = yield call(
        CapOnLoanAPI.calculateMaximumLoanAmount,
        {
          applicationId,
          productType,
          numberOfPeriods,
          period,
          futurePeriods,
          ...otherFundsParams,
        },
        accessToken,
      );
    }
    yield put(fetchCapOnLoanSuccess(payload));
    yield put(setLoadingState(false));
  } catch (error) {
    yield fork(manageAPIError, { ...error, action });
    yield put(setLoadingState(false));
  }
}

export { capOnLoanWorker };
export default capOnLoanWatcher;
